module.exports = __webpack_public_path__ + "static/media/VeryDangerousThings_Bookcover.70662e70.jpg";